export interface LegacySmmateMasterRow {
  id: string
  date: string
  time: string
  fileName: string
  group: string
  converted: string
  office: string
}

export interface LegacySmmateDetailRow {
  id: string
  category: string
  date: string
  time: string
  fileName: string
  success: number
  error: number
  office: string
  staff: string
}

export const legacySmmateBrands = ['Mock 브랜드 01', 'Mock 브랜드 02']
export const legacySmmateGroups = ['Mock 그룹 01', 'Mock 그룹 02']
export const legacySmmateOffices = ['Mock 대상지점 01', 'Mock 대상지점 02']

export const legacySmmateMasterRows: LegacySmmateMasterRow[] = [
  { id: 'mock-master-01', date: '2026-08-21', time: '09:30:00', fileName: 'mock_smmate_backup.xlsx', group: 'Mock 그룹 01', converted: '대기', office: '-' },
]

export const legacySmmateDetailRows: LegacySmmateDetailRow[] = [
  { id: 'mock-detail-01', category: '고객', date: '2026-08-21', time: '09:30:00', fileName: 'mock_customer.xlsx', success: 24, error: 0, office: '미변환', staff: 'Mock 관리자' },
  { id: 'mock-detail-02', category: '고객계약', date: '2026-08-21', time: '09:30:00', fileName: 'mock_contract.xlsx', success: 12, error: 0, office: '미변환', staff: 'Mock 관리자' },
  { id: 'mock-detail-03', category: '고객 스케줄', date: '2026-08-21', time: '09:30:00', fileName: 'mock_schedule.xlsx', success: 18, error: 1, office: '미변환', staff: 'Mock 관리자' },
  { id: 'mock-detail-04', category: '고객 상품', date: '-', time: '-', fileName: '-', success: 0, error: 0, office: '-', staff: '-' },
  { id: 'mock-detail-05', category: '고객 이력', date: '-', time: '-', fileName: '-', success: 0, error: 0, office: '-', staff: '-' },
]
